
export const CuentasMercadoLibre = [
    { Nombre: 'Todas', Id: '' },
    { Nombre: 'JARSEINDUSTRIALCOMERCIALSA', Id: 'JARSEINDUSTRIALCOMERCIALSA' },
    { Nombre: 'DR.LINEABLANCA', Id: 'DR.LINEABLANCA' },
    { Nombre: 'CASA_JARSE_SAIC', Id: 'CASA_JARSE_SAIC' },
    { Nombre: 'DR-LINEABLANCA', Id: 'DR-LINEABLANCA' },
    { Nombre: 'DRLINEABLANCA', Id: 'DRLINEABLANCA' },
    { Nombre: 'JARSEINDUSTRIALMERCADOPAGO', Id: 'JARSEINDUSTRIALMERCADOPAGO' },
    { Nombre: 'CASAJARSEMERCADOPAGO', Id: 'CASAJARSEMERCADOPAGO' },
    { Nombre: 'JARSEIGLOO', Id: 'JARSEIGLOO' },
    { Nombre: 'LORENZETTI', Id: 'LORENZETTI' },
    { Nombre: 'TOOMAX', Id: 'TOOMAX' },
    { Nombre: 'BRAM_METAL', Id: 'BRAM_METAL' },
];

export class Cuenta {

    constructor ( nickname: string, cuenta: number, esMl: boolean = false ) {
        this.Nickname = nickname;
        this.esMl = esMl;
        this.Cliente = cuenta;
    }

    public readonly Nickname: string;
    public readonly Cliente: number;
    public readonly esMl: boolean = false;

    public static toTipo ( id: string | number ): Cuenta {
        if ( typeof id === 'string' ) {
            if ( id == this.JARSEINDUSTRIALCOMERCIALSA.Nickname ) return this.JARSEINDUSTRIALCOMERCIALSA;
            else if ( id == this.TIENDAINTEX.Nickname ) return this.TIENDAINTEX;
            else if ( id == this.CJMERCADOPAGO.Nickname ) return this.CJMERCADOPAGO;
            else if ( id == this.CASA_JARSE_SAIC.Nickname ) return this.CASA_JARSE_SAIC;
            else if ( id == this.MIRIPISA.Nickname ) return this.MIRIPISA;
            else if ( id == this.DRLINEABLANCA.Nickname ) return this.DRLINEABLANCA;
            else if ( id == this.CASAJARSE.Nickname ) return this.CASAJARSE;
            else if ( id == this.DRLINEABLANCA_INDUSTRIAL.Nickname ) return this.DRLINEABLANCA_INDUSTRIAL;
            else if ( id == this.ALEJORACCA.Nickname ) return this.ALEJORACCA;
            else if ( id == this.JARSEIGLOO.Nickname ) return this.JARSEIGLOO;
            else if ( id == this.LORENZETTI.Nickname ) return this.LORENZETTI;
            else if ( id == this.TOOMAX.Nickname ) return this.TOOMAX;
            else if ( id == this.BRAM_METAL.Nickname ) return this.BRAM_METAL;
        }
        else if ( typeof id === 'number' ) {
            if ( id == this.JARSEINDUSTRIALCOMERCIALSA.Cliente ) return this.JARSEINDUSTRIALCOMERCIALSA;
            else if ( id == this.TIENDAINTEX.Cliente ) return this.TIENDAINTEX;
            else if ( id == this.CJMERCADOPAGO.Cliente ) return this.CJMERCADOPAGO;
            else if ( id == this.CASA_JARSE_SAIC.Cliente ) return this.CASA_JARSE_SAIC;
            else if ( id == this.MIRIPISA.Cliente ) return this.MIRIPISA;
            else if ( id == this.DRLINEABLANCA.Cliente ) return this.DRLINEABLANCA;
            else if ( id == this.CASAJARSE.Cliente ) return this.CASAJARSE;
            else if ( id == this.DRLINEABLANCA_INDUSTRIAL.Cliente ) return this.DRLINEABLANCA_INDUSTRIAL;
            else if ( id == this.ALEJORACCA.Cliente ) return this.ALEJORACCA;
            else if ( id == this.JARSEIGLOO.Cliente ) return this.JARSEIGLOO;
            else if ( id == this.LORENZETTI.Cliente ) return this.LORENZETTI;
            else if ( id == this.TOOMAX.Cliente ) return this.TOOMAX;
            else if ( id == this.BRAM_METAL.Cliente ) return this.BRAM_METAL;
        }

        return new Cuenta( String( id ), 0 );
    }

    public static JARSEINDUSTRIALCOMERCIALSA: Cuenta = new Cuenta( "JARSEINDUSTRIALCOMERCIALSA", 30000, true );
    public static TIENDAINTEX: Cuenta = new Cuenta( "JARSEINDUSTRIALMERCADOPAGO", 40005, false );
    public static CJMERCADOPAGO: Cuenta = new Cuenta( "CASAJARSEMERCADOPAGO", 40009, false );
    public static CASA_JARSE_SAIC: Cuenta = new Cuenta( "CASA_JARSE_SAIC", 40026, true );
    public static MIRIPISA: Cuenta = new Cuenta( "MIRIPISA", 10862, true );
    public static DRLINEABLANCA: Cuenta = new Cuenta( "DRLINEABLANCA", 10862, true );
    public static CASAJARSE: Cuenta = new Cuenta( "DR.LINEABLANCA", 40000, true );
    public static DRLINEABLANCA_INDUSTRIAL: Cuenta = new Cuenta( "DR-LINEABLANCA", 30001, true );
    public static ALEJORACCA: Cuenta = new Cuenta( "ALEJORACCA", 40030, true );
    public static JARSEIGLOO: Cuenta = new Cuenta( "JARSEIGLOO", 40022, true );
    public static LORENZETTI: Cuenta = new Cuenta( "LORENZETTI", 40011, true );
    public static TOOMAX: Cuenta = new Cuenta( "TOOMAX", 40031, true );
    public static BRAM_METAL: Cuenta = new Cuenta( "BRAM_METAL", 40032, true );

}

export class Empresa {

    constructor ( id: string, nombre: string ) {
        this.Id = id;
        this.Nombre = nombre;
    }

    public readonly Id: string;
    public readonly Nombre: string;

    public static toTipo ( id: string ): Empresa {

        if ( id == this.JARSEINDUSTRIAL.Id ) return this.JARSEINDUSTRIAL;
        else if ( id == this.CASAJARSE.Id ) return this.CASAJARSE;
        else if ( id == this.MIRIPI.Id ) return this.MIRIPI;

        return new Empresa( id, '' );
    }

    public static JARSEINDUSTRIAL: Empresa = new Empresa( "jarse-industrial", 'JARSE INDUSTRIAL S.A.I.C.' );
    public static CASAJARSE: Empresa = new Empresa( "casa-jarse", 'CASA JARSE S.A.I.C.' );
    public static MIRIPI: Empresa = new Empresa( "miripi", 'Miripi S.A.' );

    public get esJARSEINDUSTRIAL () { return this.Id == Empresa.JARSEINDUSTRIAL.Id; }
    public get esCASAJARSE () { return this.Id == Empresa.CASAJARSE.Id; }
    public get esMIRIPI () { return this.Id == Empresa.MIRIPI.Id; }
    public get Imagen () {
        if ( this.esJARSEINDUSTRIAL ) return 'https://static.jarseindustrial.com/industrial.png';
        if ( this.esCASAJARSE ) return 'https://static.jarseindustrial.com/casajarse.png';
        return '';
    }

}